"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainPrice = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const MainPrice = ({
  price,
  mrpStatementEnabled,
  immediateDiscountPriceVisible,
  oldPriceVisible,
  size
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const isMrpVisible = mrpStatementEnabled && !immediateDiscountPriceVisible && !oldPriceVisible;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [immediateDiscountPriceVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      color: "textSecondary",
      children: translations.yourPrice
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CurrentPrice, {
      component: "p",
      variant: size === 'small' ? 'h5' : 'h4',
      oldPriceVisible: oldPriceVisible,
      "data-testid": getTestId(_constants.PRICES_CURRENT_PRICE),
      children: isMrpVisible ? `${translations.mrp} ${price}` : price
    })]
  });
};
exports.MainPrice = MainPrice;
